<template>
  <div class="md:py-4 lg:py-4">
    <Create-Post-Sidebar />
    <!-- :isSidebarActive="openCreatePostSidebar" -->
    <!-- @closeSidebar="toggleCreatePostSidebar" -->
    <!-- <base-button type="primary" class="flex w-full mt-4" @click="createPost">
      <feather-icon icon="EditIcon" class="mr-1"></feather-icon>Create Post
    </base-button> -->
    <base-button type="primary" class="flex w-full py-3" @click="createPost">
      <feather-icon icon="EditIcon" class="mr-1"></feather-icon>Create Post
    </base-button>
    <!-- <button
      type="button"
      @click="handleClick"
      class="btn btn-secondary w-full mt-5 text-black font-semibold flex justify-center "
    >
      <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>New Channel
    </button> -->
    <!-- <button
      type="button"
      class="
        btn btn-secondary
        w-full
        md:mt-5
        lg:mt-5
        mt-3
        py-3
        text-black
        font-semibold
        flex
        justify-center
      "
      @click="handleClick"
    >
      <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>New Channel
    </button> -->
    <!-- <div class="my-6 border-b border-gray-400 " /> -->
  </div>
</template>

<script>
import CreatePostSidebar from "@/layout/main/components/navbar/components/CreatePostSidebar";
export default {
  components: {
    CreatePostSidebar,
  },
  data() {
    return {
      // openCreatePostSidebar: false,
      // openAddChannelSidebar: false,
    };
  },
  methods: {
    createPost() {
      // this.toggleCreatePostSidebar(true);
      this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
    },
    // toggleCreatePostSidebar(val = false) {
    //   this.openCreatePostSidebar = val;
    // },
    handleClick() {
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", true);
    },
  },
};
</script>
